var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.as,{tag:"component"},[_vm._t("default",null,{"data":_vm.data,"isLoading":_vm.isLoading,"params":_vm.params,"setParam":_vm.setParam})],2)}
var staticRenderFns = []

export { render, staticRenderFns }